import { ReactElement } from "react";
import styles from "./UserAndUserGroupTabSelector.module.less";
import { IconButton } from "client/Components";

export const enum ActiveTab {
	UserGroup = 1,
	User = 2
}

export type UserAndUserGroupTabSelectorProps = {
	value: ActiveTab;
	onChange(value: ActiveTab): void;
};

export const UserAndUserGroupTabSelector = (props: UserAndUserGroupTabSelectorProps): ReactElement => {
	const {
		value,
		onChange
	} = props;

	return (
		<div className={styles.root}>
			<IconButton
				trackingId="user-group-button"
				icon="user-group"
				size="large"
				onClick={() => onChange(ActiveTab.UserGroup)}
				kind={value === ActiveTab.UserGroup ? "primary" : "secondary"}
			/>

			<IconButton
				trackingId="user-button"
				icon="user"
				size="large"
				onClick={() => onChange(ActiveTab.User)}
				kind={value === ActiveTab.User ? "primary" : "secondary"}
			/>
		</div>
	);
};
UserAndUserGroupTabSelector.displayName = "UserAndUserGroupTabSelector";
